/**
 * WAS ZU TUN IST, WENN DIE ADRESSE KEINE KOORDINATEN HAT - AN BEIDEN KARTEN.
 *
 * ORIGINALTEXT MARVIN (05.09.2026)
 * > „bei der karte für den tiefbau vorbeiten ist das haus nicht direkt
 * >  herangezoomt, bei der planungsvorbereitung für den tiefbau ist das
 * >  schon. schau mal wo sich da dieser punkt noch unterscheidet."
 *
 * **DER ZWEITE UNTERSCHIED WAR EIN GERATENER PUNKT.** Dieser Kasten stand in
 * `seiten/Lageplankarte.tsx` und galt damit nur für den Lageplan; die Planung
 * daneben setzte bei fehlenden Koordinaten `{ lat: 50.35, lng: 7.6 }` ein -
 * die Mitte von Koblenz. Sie zeigte also eine Karte, auf der man zeichnen
 * kann, und zwar über einer fremden Stadt.
 *
 * **EIN FEHLENDER PUNKT FÄLLT AUF, EIN GERATENER NICHT.** Über dem geratenen
 * wird eine Trasse gezogen, ein Aufwand geschätzt und eine Grube gesetzt, und
 * niemand sieht dem Ergebnis an, dass es an der falschen Stelle entstand.
 * Dieselbe Regel steht seit dem 25.08.2026 an der Koordinatensuche.
 *
 * Er steht deshalb hier, ohne Seite darum, und beide Bereiche zeigen ihn.
 *
 * ----------------------------------------------------------------------------
 * UND DER WEG DARIN IST SEIT .161 EINE ANSCHRIFT UND KEINE ZWEI ZAHLEN
 * ----------------------------------------------------------------------------
 *
 * ORIGINALTEXT MARVIN (10.09.2026)
 * > „die eingabe von koordinaten kannst du bei beiden karten komplett
 * >  entfernen. wir ersetzen die eingabe damit."
 *
 * Hier standen zwei Knöpfe („Koordinaten suchen" und „Von Hand eintragen") und
 * darunter zwei Zahlenfelder mit einem Satz über die rechte Maustaste. Der
 * Knopf ist NICHT weggefallen - er hat zwei Felder danebenbekommen: wer nichts
 * eintippt, sucht weiterhin die Anschrift des Auftrags. Die Felder stehen in
 * `Adresssuche.tsx`, damit sie hier und in `Punktgenauigkeit.tsx` dieselben
 * sind.
 */
import Adresssuche, { type Anschrift } from './Adresssuche.tsx';

/**
 * Was zu tun ist, wenn die Adresse keine Koordinaten hat.
 *
 * EIN WEG, UND ER FÜHRT ÜBER DIE ANSCHRIFT. Erst suchen lassen: das kostet
 * einen Klick und geht in neun von zehn Fällen. Findet der Dienst die
 * Hausnummer nicht, kommt ein Punkt auf der Straße heraus, und der Kasten von
 * `Punktgenauigkeit.tsx` sagt es - **ein Punkt, den man als ungenau erkennt,
 * ist kein geratener.** Wer es genauer braucht, sucht eine Nachbarnummer.
 */
export default function KeinePunkte(
  { auftragId, text, anschrift, fertig }: {
    auftragId: string;
    text: string;
    anschrift?: Anschrift | null;
    fertig: () => void;
  }
) {
  return (
    <div className="hinweis warnung">
      <b>Die Karte kann nicht gezeigt werden</b>
      <div className="klein">{text}</div>
      <Adresssuche auftragId={auftragId} anschrift={anschrift}
                   aufschrift="Punkt suchen" fertig={fertig} />
    </div>
  );
}
